import { trigger, transition, style, animate, query } from '@angular/animations';

export const ANIMATION_TIME = 1000;

export const COUNTDOWN_CLOCK_ANIMATIONS = [
    trigger('displayNewNumber', [
        // Animate the new number entering the page
        transition(':enter', [
            style({ transform: 'translateY(-100%)', opacity: 0 }),
            animate(ANIMATION_TIME / 2, style({ transform: 'translateY(0)', opacity: 1 }))
        ]),
        // Animate the old number leaving the page
        transition(':leave', [
            // Find the 1s character
            query('div[data-position="1"]', [
                // Move the old character all the way to the right of the container
                style({position: 'absolute', right: '0'})
            ], {optional: true}),
            // Find the 10s character
            query('div[data-position="2"]', [
                style({position: 'absolute', right: '0.55em'})
            ], {optional: true}),
            // Find the 100s character
            query('div[data-position="3"]', [
                style({position: 'absolute', right: '1.1em'})
            ], {optional: true}),
            // Make sure the number slides outside of the div and not just disappears part of the way
            animate(ANIMATION_TIME / 2, style({ transform: 'translateY(130%)', opacity: 0 }))
        ])
    ])
];
